<template>
  <div class="row mt-2">
    <v-input
      input-id="account-owner"
      label="Titulaire du compte"
      getter-name="accountOwner"
      :module-name="moduleName"
      path="accountOwner"
      placeholder="Nicolas Moreau"
    />
    <div class="text-start d-flex flex-column mt-auto">
      <label
        :for="elementId"
        class="text-secondary my-2"
      > {{ label }} </label>
      <div :id="elementId" />
      <div class="mt-1">
        <small style="font-style: italic;font-weight: bold;">
          En confirmant ce paiement, vous autorisez Assurup et Stripe à envoyer
          des instructions à votre banque pour débiter votre compte et votre banque
          à débiter votre compte bancaire conformément aux instructions de ASSURUP.
          Vous bénéficiez du droit d'être remboursé par votre banque selon les conditions
          décrites dans la convention que vous avez passée avec elle.
          Une demande de remboursement doit être présentée dans les 8 semaines
          suivants la date de prélèvement.
        </small>
      </div>
    </div>
    <div class="col-12">
      <transition
        tag="div"
        @enter="tf_slideDown"
        @leave="tf_slideUp"
      >
        <div
          v-if="event.error !== undefined"
          id="iban-error"
          class="animated"
        >
          <small
            role="alert"
            class="text-danger"
            v-text="event.error.message"
          />
        </div>
      </transition>
    </div>
    <div class="col-12">
      <transition
        tag="div"
        @enter="tf_slideDown"
        @leave="tf_slideUp"
      >
        <div
          v-if="error !== null"
          class="col-12 mt-2"
        >
          <div class="text-danger text-center">
            {{ error }}
          </div>
        </div>
      </transition>
      <v-loader
        id="stripe_submit"
        :next="payment"
        :title="computedSubmitTitle"
        icon="arrow-white-right"
        class="my-3 w-100"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { transform } from '@/mixins';
import { formatPrice } from '@/utils/_Number';
import Input from '@/components/common/input/Input2.vue';

export default {
  name: 'StripeIban',
  components: {
    'v-input': Input,
  },
  mixins: [transform],
  props: {
    price: {
      type: Number,
      required: false,
      default: 0,
    },
    isSetupMode: {
      type: Boolean,
      default: false,
    },
    elementId: {
      type: String,
      default: 'iban',
    },
    moduleName: {
      type: String,
      default: 'checkout',
    },
    submitTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      label: 'IBAN',
      event: {},
      container: {},
      stripe: {},
      error: null,
      setted: false,
    };
  },
  computed: {
    ...mapGetters({
      transaction: 'checkout/transaction',
    }),
    computedSubmitTitle() {
      if (this.submitTitle) return this.submitTitle;
      if (this.isSetupMode) return 'Enregistrer mon nouveau RIB';
      return `Payer ${this.format(this.price)} €`;
    },
  },
  watch: {
    transaction: {
      deep: true,
      handler(value) {
        if (!this.isSetupMode && value && !this.setted) {
          this.stripe = window.Stripe(import.meta.env.VITE_STRIPE_KEY);
          this.setContainer();
          this.setted = true;
        }
      },
    },
  },
  mounted() {
    if (this.isSetupMode || (this.transaction && this.transaction.id)) {
      this.stripe = window.Stripe(import.meta.env.VITE_STRIPE_KEY);
      this.setContainer();
      this.setted = true;
    }
  },
  beforeUnmount() {
    this.unsetContainer();
  },
  methods: {
    unsetContainer() {
      if (this.container && this.container.destroy) {
        this.container.destroy();
      }
      this.container = null;
      this.event = {};
    },
    setContainer() {
      const { stripe } = this;
      if (stripe) {
        const elements = stripe.elements();
        this.container = elements.create('iban', {
          supportedCountries: ['SEPA'],
          placeholderCountry: 'FR',
          placeholder: '1234 1234 1234 1234',
          classes: {
            base: 'form-control h-100',
            complete: 'input-valid',
            invalid: 'input-invalid',
          },
        });
        this.container.mount(`#${this.elementId}`);
        this.container.addEventListener('change', (event) => {
          this.event = event;
        });
      }
    },
    async payment() {
      const { stripe, container } = this;
      try {
        if (this.isSetupMode) {
          await this.$store.dispatch('payments/addIban', [stripe, container]);
          await this.$store.dispatch('payments/getPaymentMethods');
          this.$emit('payment:success');
          return;
        }

        await this.$store.dispatch('checkout/paymentIban', [stripe, container]);
        this.$store.dispatch('analytics/purchase');
        this.$emit('payment:success');
      } catch (err) {
        this.error = 'Erreur, veuillez réessayer ultérieurement';
      }
    },
    format: (price) => formatPrice(price, true),
  },
};
</script>
